import React from 'react'
import PropTypes from 'prop-types';

const RegionCardBody = ({
  className,
  classNames,
  children,
  style
}) => {
  return (
    <div className={`card-body ${classNames || ""} ${className || ""}`} style={{...style}}>
      {children}
    </div>
  );
}

RegionCardBody.propTypes = {
  className: PropTypes.string,
  /**
   * @deprecated Use className instead
   */
  classNames: PropTypes.string,
  children: PropTypes.element
}

export default RegionCardBody;